module.exports = __webpack_public_path__ + "img/wave-path.02f963b8.svg";